module.exports = __webpack_public_path__ + "img/hand.e43296e9.svg";